import { spawn } from 'redux-saga/effects';
import { sagas as consoleSagas } from './console';
import { sagas as taskSchedulerSagas } from './taskScheduler';

export default function* sagas() {
	yield spawn(taskSchedulerSagas);
	yield spawn(consoleSagas);
}
